import { Mail, Phone, MapPin, Clock } from "lucide-react";
import { MaskedLines, FadeUp } from "@/components/motion";
import { Container } from "@/components/Section";
import LeadForm from "@/components/LeadForm";

export default function Assessment() {
  return (
    <main data-testid="assessment-page">
      <section className="noise-dark bg-forest pb-28 pt-44 text-cream sm:pb-36 sm:pt-52">
        <Container className="relative z-10 grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <FadeUp>
              <p className="eyebrow text-sage">Property assessment</p>
            </FadeUp>
            <MaskedLines
              className="mt-6"
              lineClassName="font-serif text-4xl sm:text-5xl lg:text-6xl font-medium leading-[1.06]"
              lines={[
                <span key="1">See what your property</span>,
                <span key="2" className="italic text-sage-light">could earn.</span>,
              ]}
            />
            <FadeUp delay={0.3}>
              <p className="mt-7 max-w-lg text-base sm:text-lg leading-relaxed text-cream/70">
                Tell us a little about your property and we'll assess whether short-term management — or a
                corporate stay strategy of 21+ days — could make sense for you. Realistic figures, honest advice,
                no obligation.
              </p>
            </FadeUp>

            <FadeUp delay={0.4}>
              <div className="mt-12 space-y-6 border-t border-white/10 pt-10">
                {[
                  { icon: Clock, t: "What happens next", d: "We review your property against live Dublin market data and respond within one working day." },
                  { icon: Mail, t: "stay@fieldgreenproperty.com", d: "Prefer email? Send your property details directly." },
                  { icon: Phone, t: "+353 85 736 2033 — Andrew", d: "Mon–Fri, 9am–6pm. We're happy to talk it through." },
                  { icon: MapPin, t: "Dublin, Ireland", d: "Managing properties across the city and suburbs." },
                ].map(({ icon: Icon, t, d }, i) => (
                  <div key={t} className="flex items-start gap-4" data-testid={`contact-item-${i}`}>
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-sage/25 bg-sage/10 text-sage">
                      <Icon className="h-4 w-4" />
                    </span>
                    <div>
                      <p className="text-sm font-semibold text-cream">{t}</p>
                      <p className="mt-1 text-sm leading-relaxed text-cream/60">{d}</p>
                    </div>
                  </div>
                ))}
              </div>
            </FadeUp>
          </div>

          <FadeUp delay={0.2} className="lg:col-span-6">
            <LeadForm source="assessment-page" />
          </FadeUp>
        </Container>
      </section>
    </main>
  );
}
